module.exports = __webpack_public_path__ + "assets/media/4.c7b1676e.wav";